var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bag-inscan-logs"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("Hub Inscan Logs")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Bag Number")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagNo),
      expression: "bagNo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "bagNo",
      "placeholder": "Enter Bag Number"
    },
    domProps: {
      "value": (_vm.bagNo)
    },
    on: {
      "keyup": _vm.clearError,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagNo = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), (_vm.isBagNoError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.bagNoError))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "28px"
    }
  }, [_c('b-input-group', [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getShipmentDetails
    }
  }, [_vm._v("Search")])])], 1)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "margin-top": "60px"
    }
  }, [(_vm.showtable) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Number")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Created By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Request")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.responseDetails), function(sdata, ind) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.BagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.requestData.createdDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(sdata.requestData.OperatorID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "fa fa-eye",
      staticStyle: {
        "cursor": "pointer",
        "color": "#20a8d8"
      },
      on: {
        "click": function($event) {
          return _vm.showRequestLog(sdata.requestData)
        }
      }
    })])])
  }), _vm._v(" "), (_vm.responseDetails.length == 0) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)]) : _vm._e()]), _vm._v(" "), (_vm.showRequestModal) ? _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Request Log"
    },
    model: {
      value: (_vm.showRequestModal),
      callback: function($$v) {
        _vm.showRequestModal = $$v
      },
      expression: "showRequestModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Request Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeRequestModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "450px"
    }
  }, [_c('pre', {
    staticClass: "prettyprint",
    staticStyle: {
      "background": "#000",
      "color": "green",
      "font-weight": "600"
    }
  }, [_vm._v(_vm._s(_vm.requestLogData))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-danger pull-right",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeRequestModal
    }
  }, [_vm._v("Close")])])])])]) : _vm._e()], 1)])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509a0fe2","hasScoped":true}!./src/views/components/BagSorter/BagInscanLogs/BagInscanLogs.html
// module id = 1821
// module chunks = 2